/**
 * Public routes where anonymous users are allowed and auth bootstrap should be skipped.
 * Keep onboarding paths explicit so protected onboarding routes stay protected.
 */
export const PUBLIC_AUTH_OPTIONAL_EXACT_PATHS = [
  '/onboarding',
  '/onboarding/start',
  '/onboarding/email-sent',
  '/onboarding/verify',
  '/onboarding/choose',
] as const;

export const PUBLIC_AUTH_OPTIONAL_PATH_PREFIXES = ['/MKE-ERA', '/government-intake'] as const;

function normalizePath(pathname: string): string {
  if (!pathname) {
    return '/';
  }

  const normalized = pathname.replace(/\/+$/, '');
  return normalized === '' ? '/' : normalized;
}

export function isPublicAuthOptionalPath(pathname: string): boolean {
  const normalizedPath = normalizePath(pathname);

  if (PUBLIC_AUTH_OPTIONAL_EXACT_PATHS.some((path) => path === normalizedPath)) {
    return true;
  }

  return PUBLIC_AUTH_OPTIONAL_PATH_PREFIXES.some((prefix) => normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`));
}
